<template>
  <div class="toggle" :class="{ checked: value, disabled }" @click="onInput" @keyup.enter="onInput" role="checkbox" tabindex="0">
    <div class="track">
        <div class="toggle-button"></div>
    </div>
    <div v-if="label" class="label ri-bold-body">{{ label }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput() {
      if (!this.disabled) {
        this.$emit('input', !this.value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/riseup-colors";
@import "../scss/border-radius";
@import "../scss/spacings";

.toggle {
  display: flex;
  align-items: flex-start;
  height: 24px;
  cursor: pointer;
  .track {
    display: flex;
    background-color: $riseup_gray_10;
    border-radius: $ri-border-radius-medium;
    height: 24px;
    width: 40px;
    min-width: 40px;
    transition: background-color 0.2s ease-in-out;
  }
  .toggle-button {
    background-color: $riseup_gray_40;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    margin-top: 2px;
    margin-inline-start: 2px;
    transition: margin-inline-start 0.2s ease-in-out, background-color 0.2s ease-in-out;
  }
  .label {
    color: $riseup_black;
    margin-inline-start: $ri-spacing-s;
    transition: color 0.2s ease-in-out;
  }

  &.checked {
    .track {
      background-color: $riseup_light_blue;
    }
    .toggle-button {
      background-color: $riseup_blue;
      margin-inline-start: 18px;
    }
    .label {
      color: $riseup_blue;
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
